import Model from 'flarum/Model';
import mixin from 'flarum/utils/mixin';

export default class HeroTagHeroLevel extends mixin(Model, {
  heroIntroId: Model.attribute('heroIntroId'),
  level: Model.attribute('level'),
  introduction: Model.attribute('introduction'),
}) {
  apiEndpoint() {
    return '/heroTagHeroLevel' + (this.exists ? '/' + this.data.id : '');
  }
}
